import React from 'react';
import './button.style.scss';

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  type?: 'submit' | 'reset' | 'button';
  children?: React.ReactNode;
  primary?: boolean;
  secondary?: boolean;
}

const Button: React.FC<IProps> = ({ type = 'button', children, primary, secondary, ...rest }) => {
  return (
    <button
      type={type}
      className={`btn ${primary && 'btn__primary'} ${secondary && 'btn__secondary'}`}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
